module.exports = __webpack_public_path__ + "img/comment.021854ed.svg";